module.exports = __webpack_public_path__ + "img/icon_form_down@2x.0af68058.png";